var render = function () {
  var _vm$quotationList;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return ((_vm$quotationList = _vm.quotationList) === null || _vm$quotationList === void 0 ? void 0 : _vm$quotationList.length) > 0 ? _c('div', {
    staticClass: "packageWrap"
  }, _vm._l(_vm.quotationList, function (parent, index) {
    var _parent$supplier, _parent$invoiceTempla, _parent$bankAccountLi13, _parent$bankAccountLi14, _parent$bankAccountLi15, _parent$bankAccountLi16, _parent$bankAccountLi17, _parent$bankAccountLi18;

    return _c('div', {
      key: "parent".concat(index),
      staticClass: "shadeWrap"
    }, [_c('el-row', {
      staticClass: "pt10 pb10 fxRow borderTop",
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('p', {
      staticClass: "pl4 fs14 fwb billingTo"
    }, [_vm._v(" Client Code: "), _c('span', {
      staticClass: "fw400 fs12"
    }, [_vm._v(_vm._s(parent.clientCode))])])]), _c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_c('p', {
      staticClass: "pl4 fs14 fwb billingTo"
    }, [_vm._v(" Billing to: "), _c('span', {
      staticClass: "fw400 fs12"
    }, [_vm._v(_vm._s(parent.companyTitle))])])]), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('p', {
      staticClass: "fs14 fwb billingTo"
    }, [_vm._v(" Address: "), _c('span', {
      staticClass: "fw400 fs12"
    }, [_vm._v(_vm._s(parent.companyAddress))])])]), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('p', {
      staticClass: "fs14 fwb billingTo"
    }, [_vm._v(" Country: "), _c('span', {
      staticClass: "fw400 fs12"
    }, [_vm._v(_vm._s(parent.companyCountry))])])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs14 fwb billingTo"
    }, [_vm._v(" Code: "), _c('span', {
      staticClass: "fw400 fs12"
    }, [_vm._v(_vm._s(parent.companyPostalCode))])])])], 1), _c('el-row', {
      staticClass: "pt10 pb10 fxRow borderTop",
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('p', {
      staticClass: "pl4 fs14 fwb billingTo"
    }, [_vm._v(" Supplier: "), _c('span', {
      staticClass: "fw400 fs12"
    }, [_vm._v(_vm._s(((_parent$supplier = parent.supplier) === null || _parent$supplier === void 0 ? void 0 : _parent$supplier.companyName) || ""))])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('p', {
      staticClass: "fs14 fwb billingTo"
    }, [_vm._v(" Invoice Template: "), _c('span', {
      staticClass: "fw400 fs12"
    }, [_vm._v(_vm._s(((_parent$invoiceTempla = parent.invoiceTemplate) === null || _parent$invoiceTempla === void 0 ? void 0 : _parent$invoiceTempla.templateName) || ""))])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('p', {
      staticClass: "fs14 fwb billingTo"
    }, [_vm._v(" Bank Accounts: "), _c('span', {
      staticClass: "fw400 fs12"
    }, [_vm._v(_vm._s(_vm.getBankAccountTags(parent)))])])])], 1), _c('div', {
      staticClass: "billingTitle"
    }, [_c('el-row', {
      staticClass: "pt10 pb10 fxRow borderTop",
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Fee Schedule")])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Covered Period")])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Amount")])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Incl. Third Party Fee")])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Incl. Other Fee")])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Payment Due Date")])]), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Generic Invoice")])]), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Status")])])], 1)], 1), _vm._l(parent.partList, function (sub, idx) {
      var _parent$bankAccountLi7, _parent$bankAccountLi8, _parent$bankAccountLi9, _parent$bankAccountLi10, _parent$bankAccountLi11, _parent$bankAccountLi12;

      return _c('div', {
        key: "sub".concat(idx),
        staticClass: "billingPart"
      }, [_vm._l(sub.itemList, function (grand, ids) {
        var _parent$bankAccountLi, _parent$bankAccountLi2, _parent$bankAccountLi3, _parent$bankAccountLi4, _parent$bankAccountLi5, _parent$bankAccountLi6;

        return _c('div', {
          key: "grand".concat(ids),
          staticClass: "billingContent"
        }, [_c('el-row', {
          staticClass: "pt10 pb10 fxRow borderTop",
          attrs: {
            "gutter": 10
          }
        }, [_c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_c('p', {
          staticClass: "fs12 tac lh16"
        }, [_vm._v(_vm._s(grand.title))])]), _c('el-col', {
          attrs: {
            "span": 3
          }
        }, [_c('p', {
          staticClass: "fs12 tac lh16"
        }, [_vm._v(_vm._s(grand.startDate) + " ~ " + _vm._s(grand.endDate))])]), _c('el-col', {
          attrs: {
            "span": 3
          }
        }, [_c('p', {
          staticClass: "fs12 tac lh16 orange newline"
        }, [_vm._v(_vm._s(_vm.currencySymbolFormat(parent === null || parent === void 0 ? void 0 : (_parent$bankAccountLi = parent.bankAccountList) === null || _parent$bankAccountLi === void 0 ? void 0 : (_parent$bankAccountLi2 = _parent$bankAccountLi[0]) === null || _parent$bankAccountLi2 === void 0 ? void 0 : _parent$bankAccountLi2.billingCurrency)) + _vm._s(grand.amount))])]), _c('el-col', {
          attrs: {
            "span": 3
          }
        }, [_c('p', {
          staticClass: "fs12 tac lh16 orange newline"
        }, [_vm._v(" " + _vm._s(_vm.currencySymbolFormat(parent === null || parent === void 0 ? void 0 : (_parent$bankAccountLi3 = parent.bankAccountList) === null || _parent$bankAccountLi3 === void 0 ? void 0 : (_parent$bankAccountLi4 = _parent$bankAccountLi3[0]) === null || _parent$bankAccountLi4 === void 0 ? void 0 : _parent$bankAccountLi4.billingCurrency)) + _vm._s(grand.thirdPartyFee) + " "), grand.noteForThirdParty ? _c('el-popover', {
          attrs: {
            "placement": "bottom",
            "trigger": "hover"
          }
        }, [_c('p', {
          staticClass: "fs12 m0"
        }, [_vm._v(_vm._s(grand.noteForThirdParty))]), _c('span', {
          staticClass: "fs13 blackD8 el-icon-question",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        })]) : _vm._e()], 1)]), _c('el-col', {
          attrs: {
            "span": 3
          }
        }, [_c('p', {
          staticClass: "fs12 tac lh16 orange newline"
        }, [_vm._v(" " + _vm._s(_vm.currencySymbolFormat(parent === null || parent === void 0 ? void 0 : (_parent$bankAccountLi5 = parent.bankAccountList) === null || _parent$bankAccountLi5 === void 0 ? void 0 : (_parent$bankAccountLi6 = _parent$bankAccountLi5[0]) === null || _parent$bankAccountLi6 === void 0 ? void 0 : _parent$bankAccountLi6.billingCurrency)) + _vm._s(grand.otherFee) + " "), grand.noteForOther ? _c('el-popover', {
          attrs: {
            "placement": "bottom",
            "trigger": "hover"
          }
        }, [_c('p', {
          staticClass: "fs12 m0"
        }, [_vm._v(_vm._s(grand.noteForOther))]), _c('span', {
          staticClass: "fs13 blackD8 el-icon-question",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        })]) : _vm._e()], 1)]), _c('el-col', {
          attrs: {
            "span": 3
          }
        }), _c('el-col', {
          attrs: {
            "span": 2
          }
        }), _c('el-col', {
          attrs: {
            "span": 2
          }
        })], 1)], 1);
      }), _c('div', {
        staticClass: "billingBrief"
      }, [_c('el-row', {
        staticClass: "pt10 pb10 fxRow borderTop borderBottom",
        attrs: {
          "gutter": 10
        }
      }, [_c('el-col', {
        attrs: {
          "span": 5
        }
      }, [_c('p', {
        staticClass: "fs12 tac lh16"
      }, [_vm._v(_vm._s(sub.subTotalDesp))])]), _c('el-col', {
        attrs: {
          "span": 3
        }
      }), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_c('p', {
        staticClass: "fs12 tac lh16 pb2"
      }, [_vm._v("Subtotal")]), _c('p', {
        staticClass: "fs12 tac lh16 fwb orange newline"
      }, [_vm._v(" " + _vm._s(_vm.currencySymbolFormat(parent === null || parent === void 0 ? void 0 : (_parent$bankAccountLi7 = parent.bankAccountList) === null || _parent$bankAccountLi7 === void 0 ? void 0 : (_parent$bankAccountLi8 = _parent$bankAccountLi7[0]) === null || _parent$bankAccountLi8 === void 0 ? void 0 : _parent$bankAccountLi8.billingCurrency)) + _vm._s(sub.subTotalPrice) + " ")])]), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_c('p', {
        staticClass: "fs12 tac lh16 pb2"
      }, [_vm._v("Subtotal")]), _c('p', {
        staticClass: "fs12 tac lh16 fwb orange newline"
      }, [_vm._v(" " + _vm._s(_vm.currencySymbolFormat(parent === null || parent === void 0 ? void 0 : (_parent$bankAccountLi9 = parent.bankAccountList) === null || _parent$bankAccountLi9 === void 0 ? void 0 : (_parent$bankAccountLi10 = _parent$bankAccountLi9[0]) === null || _parent$bankAccountLi10 === void 0 ? void 0 : _parent$bankAccountLi10.billingCurrency)) + _vm._s(sub.subTotalThirdPartyFee) + " ")])]), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [_c('p', {
        staticClass: "fs12 tac lh16 pb2"
      }, [_vm._v("Subtotal")]), _c('p', {
        staticClass: "fs12 tac lh16 fwb orange newline"
      }, [_vm._v(" " + _vm._s(_vm.currencySymbolFormat(parent === null || parent === void 0 ? void 0 : (_parent$bankAccountLi11 = parent.bankAccountList) === null || _parent$bankAccountLi11 === void 0 ? void 0 : (_parent$bankAccountLi12 = _parent$bankAccountLi11[0]) === null || _parent$bankAccountLi12 === void 0 ? void 0 : _parent$bankAccountLi12.billingCurrency)) + _vm._s(sub.subTotalOtherFee) + " ")])]), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [sub.isDownPayment ? _c('p', {
        staticClass: "fs12 tac lh16"
      }, [_vm._v("Payable upon submission")]) : _c('p', {
        staticClass: "fs12 tac lh16"
      }, [_vm._v(_vm._s(sub.paymentDueTime))])]), _c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_vm.getInvoiceNumber(sub.id, 1) ? [_c('p', {
        staticClass: "fs12 tac lh16 crp blue",
        on: {
          "click": function click($event) {
            _vm.invoiceLink(_vm.getInvoiceNumber(sub.id, 1));
          }
        }
      }, [_vm._v("Invoice")])] : _vm._e(), _vm.getInvoiceNumber(sub.id, 2) ? [_c('p', {
        staticClass: "fs12 tac lh16 crp blue pt4",
        on: {
          "click": function click($event) {
            _vm.invoiceLink(_vm.getInvoiceNumber(sub.id, 2));
          }
        }
      }, [_vm._v("Credit Invoice")])] : _vm._e()], 2), _c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_c('p', {
        staticClass: "fs12 tac lh16"
      }, [_vm._v(_vm._s(_vm.getOrderStatus(sub.id)))])])], 1), _c('div', {
        staticClass: "wdb100 hg40"
      })], 1)], 2);
    }), _c('div', {
      staticClass: "billingBottom"
    }, [_c('el-row', {
      staticClass: "pt10 pb10 fxRow borderTop borderBottom",
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('p', {
      staticClass: "fs12 text-center lh16"
    }, [_vm._v(_vm._s(parent.sumTotalDesp))])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs12 text-center lh16 pb2"
    }, [_vm._v("Total")]), _c('p', {
      staticClass: "fs12 text-center lh16 fwb orange newline"
    }, [_vm._v(" " + _vm._s(_vm.currencySymbolFormat(parent === null || parent === void 0 ? void 0 : (_parent$bankAccountLi13 = parent.bankAccountList) === null || _parent$bankAccountLi13 === void 0 ? void 0 : (_parent$bankAccountLi14 = _parent$bankAccountLi13[0]) === null || _parent$bankAccountLi14 === void 0 ? void 0 : _parent$bankAccountLi14.billingCurrency)) + _vm._s(parent.sumTotalPrice) + " ")])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs12 text-center lh16 pb2"
    }, [_vm._v("Total")]), _c('p', {
      staticClass: "fs12 text-center lh16 fwb orange newline"
    }, [_vm._v(" " + _vm._s(_vm.currencySymbolFormat(parent === null || parent === void 0 ? void 0 : (_parent$bankAccountLi15 = parent.bankAccountList) === null || _parent$bankAccountLi15 === void 0 ? void 0 : (_parent$bankAccountLi16 = _parent$bankAccountLi15[0]) === null || _parent$bankAccountLi16 === void 0 ? void 0 : _parent$bankAccountLi16.billingCurrency)) + _vm._s(parent.sumTotalThirdPartyFee) + " ")])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs12 text-center lh16 pb2"
    }, [_vm._v("Total")]), _c('p', {
      staticClass: "fs12 text-center lh16 fwb orange newline"
    }, [_vm._v(" " + _vm._s(_vm.currencySymbolFormat(parent === null || parent === void 0 ? void 0 : (_parent$bankAccountLi17 = parent.bankAccountList) === null || _parent$bankAccountLi17 === void 0 ? void 0 : (_parent$bankAccountLi18 = _parent$bankAccountLi17[0]) === null || _parent$bankAccountLi18 === void 0 ? void 0 : _parent$bankAccountLi18.billingCurrency)) + _vm._s(parent.sumTotalOtherFee) + " ")])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }), _c('el-col', {
      attrs: {
        "span": 2
      }
    }), _c('el-col', {
      attrs: {
        "span": 2
      }
    })], 1)], 1)], 2);
  }), 0) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }